import { motion } from "framer-motion";

interface CoreValue {
  emoji: string;
  title: string;
  description: string;
}

export const CoreValuesSection = () => {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 },
  };

  const coreValues: CoreValue[] = [
    {
      emoji: "🤝",
      title: "Together",
      description:
        "We believe in the power of collaboration. By working as one, we amplify our strengths, share knowledge, and create impactful solutions no one can achieve alone.",
    },
    {
      emoji: "🔑",
      title: "Ownership",
      description:
        "We take responsibility for every action and outcome. We lead with accountability, embracing challenges and delivering results with integrity and purpose.",
    },
    {
      emoji: "🎯",
      title: "Customer-Centric",
      description:
        "We put our customers at the heart of every decision. We simplify processes, anticipate needs, and create solutions designed to make life easier and businesses more efficient.",
    },
    {
      emoji: "💡",
      title: "Innovation",
      description:
        "We fuel progress through curiosity and creative thinking. Driven by passion and a desire to explore, we challenge norms, rethink possibilities, and deliver game-changing solutions.",
    },
    {
      emoji: "❤️",
      title: "Care",
      description:
        "We care deeply about our people, customers, and communities. We lead with empathy, treating everyone with kindness and respect while making decisions that create positive, lasting impacts.",
    },
  ];

  return (
    <motion.section {...fadeIn} className="space-y-8">
      <h2 className="text-3xl font-semibold text-left">What We Stand For – Our Core Values</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {coreValues.map((value, index) => (
          <motion.div
            key={value.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            className="p-6 rounded-lg border bg-card hover:shadow-sm transition-shadow text-left"
          >
            <div className="text-4xl mb-4">{value.emoji}</div>
            <h3 className="text-xl font-semibold mb-2">{value.title}</h3>
            <p className="text-muted-foreground">{value.description}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
};